import { ReduxSimpleActionInterface } from '@ecommerce/nest-ssr/dist/common';
import OfferInterface from '../interfaces/offer.interface';
import hasActiveFilter from '../helpers/has-active-filter';
import { offersSort } from 'helpers/offers-sort';

export enum OffersActions {
    BestOffer = 'OFFERS_SORT_BY_SCORE',
    Price = 'OFFERS_SORT_BY_PRICE_DESC',
    ShopScore = 'OFFERS_SORT_BY_SHOP_SCORE',
    Filter = 'OFFERS_FILTER'
}

export enum SortType {
    BestOffer = 'SORT_BY_SCORE',
    Price = 'SORT_BY_PRICE_DESC',
    ShopScore = 'SORT_BY_SHOP_SCORE'
}

export interface OffersState {
    items: OfferInterface[];
    prepared: OfferInterface[];
    count: number;
    activeFilters: string[];
    activeSort: SortType;
}

export const offers = [
    (
        state: OffersState,
        action: ReduxSimpleActionInterface<OffersActions.BestOffer> |
        ReduxSimpleActionInterface<OffersActions.ShopScore> |
        ReduxSimpleActionInterface<OffersActions.Price> |
        ReduxSimpleActionInterface<OffersActions.Filter, { payload: { activeFilters: string[]; }; }>
    ): OffersState => {
        switch (action.type) {
            case OffersActions.BestOffer:
                return {
                    ...state,
                    prepared: [...state.items]
                        .filter(offer => hasActiveFilter(state.activeFilters, offer.dealer))
                        .sort(offersSort(SortType.BestOffer)),
                    activeSort: SortType.BestOffer
                };
            case OffersActions.ShopScore:
                return {
                    ...state,
                    prepared: [...state.items]
                        .filter(offer => hasActiveFilter(state.activeFilters, offer.dealer))
                        .sort(offersSort(SortType.ShopScore)),
                    activeSort: SortType.ShopScore
                };
            case OffersActions.Price:
                return {
                    ...state,
                    prepared: [...state.items]
                        .filter(offer => hasActiveFilter(state.activeFilters, offer.dealer))
                        .sort(offersSort(SortType.Price)),
                    activeSort: SortType.Price
                };
            case OffersActions.Filter:
                return {
                    ...state,
                    prepared: [...state.items]
                        .filter(offer => hasActiveFilter(action.payload.activeFilters, offer.dealer))
                        .sort(offersSort(state.activeSort)),
                    activeFilters: action.payload.activeFilters
                };

            default:
                return state;
        }
    }
];
